import { PORTFOLIO } from '../data';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p className="footer__copy">
        © {new Date().getFullYear()} {PORTFOLIO.name}. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
